import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class ConnectionService {
	constructor(private http: HttpClient) { }

	getToken(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:getToken',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	connectldap(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:connectldap',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	connect(login: string, password: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:connect',
			params: {
				login: login,
				password: password,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	isconnected(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:isconnected',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	user(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:user',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	password(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:password',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	connectAtylV2(id: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:connectAtylV2',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	send401(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:send401',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	logout(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:logout',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	versions(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:versions',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	

}
